import type { FlowConfig } from '@logistiek-zonder-papier/lzp-library'
import { computed, ref, type Ref } from 'vue'

export function useFlowConfigValidation(config: Ref<Partial<FlowConfig>>) {
  const submitted = ref(false)

  const errors = computed<Partial<Record<keyof FlowConfig, string>>>(() => {
    const data = config.value
    const result: Partial<Record<keyof FlowConfig, string>> = {}

    if (!data.label?.trim()) result.label = 'Label is verplicht'
    if (!data.description?.trim()) result.description = 'Beschrijving is verplicht'
    if (!data.type?.trim()) result.type = 'Type is verplicht'

    return result
  })

  const isValid = computed(() => Object.keys(errors.value).length === 0)
  const visibleErrors = computed<Partial<Record<keyof FlowConfig, string>>>(() => {
    if (!submitted.value) return {}
    return errors.value
  })

  function validate(): boolean {
    submitted.value = true
    return isValid.value
  }

  return { visibleErrors, errors, isValid, validate }
}
